import axios from 'axios';
import { API_URL } from '../config/api';

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getOffers = async () => {
  const response = await axios.get(`${API_URL}/payment/offers`);
  return response.data;
};

export const createCheckoutSession = async (priceId) => {
  const response = await axios.post(
    `${API_URL}/payment/create-checkout-session`,
    { priceId },
    { headers: getAuthHeaders() }
  );
  return response.data;
};

export const getSubscriptionStatus = async () => {
  const response = await axios.get(`${API_URL}/payment/subscription`, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

export const cancelSubscription = async () => {
  const response = await axios.post(
    `${API_URL}/payment/cancel-subscription`,
    {},
    { headers: getAuthHeaders() }
  );
  return response.data;
};

export const getTransactionHistory = async (page = 1) => {
  const response = await axios.get(`${API_URL}/payment/history?page=${page}`, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

export const createCustomerPortal = async () => {
  const response = await axios.post(
    `${API_URL}/payment/customer-portal`,
    {},
    { headers: getAuthHeaders() }
  );
  return response.data;
};
